import { Component, Emit, Model, Prop, Vue } from 'vue-property-decorator';
import TaskList from '@/components/TaskList/TaskList.vue';
import { Report } from '@/models/Report';
import { Task } from '@/models/Task';
import { AxiosError } from 'axios';
import ErrorHandler from '@/support/ErrorHandler';
import { clone } from 'lodash';

@Component<Instructions>({
  components: {
    TaskList,
  },
})
export default class Instructions extends Vue {
  protected $pageTitle = 'Begeleidende tekst';

  @Model('report', { default: () => new Report() })
  protected report!: Report;

  @Model('readOnly', { default: false })
  protected readOnly = false;

  @Prop({ default: false })
  protected syncing!: boolean;

  protected isEditingInstructions = false;

  protected instructions = '';

  @Emit()
  protected instructionsUpdated(): string { return ''; }

  protected mounted(): void {
    if (this.report && this.report.instructions) {
      this.instructions = clone(this.report.instructions);
    }
  }

  protected async updateInstructions(): Promise<void> {
    await this.report.update({ instructions: this.instructions })
      .then(() => {
        this.isEditingInstructions = false;
        this.instructionsUpdated();
      })
      .catch((error: AxiosError) => {
        ErrorHandler.network(error);
      });
  }
}
